module.exports = __webpack_public_path__ + "img/stock7.c006e1b4.png";